import { GlobalStyles } from '@mui/material'
import React, { StrictMode } from 'react'

import LanguageProvider from 'components/LanguageProvider'
import spaces from 'components/PageLayout/spaces'
import StyleProvider from 'components/StyleProvider'
import Login from 'pages/Login/Login'
import { setWindowLocaleName } from 'utils/systemLocales'

setWindowLocaleName()

function AppLogin() {
  return (
    <StrictMode>
      <LanguageProvider>
        <StyleProvider>
          <GlobalStyles styles={spaces} />
          <Login />
        </StyleProvider>
      </LanguageProvider>
    </StrictMode>
  )
}

export default AppLogin
